import { formatDate } from '@ott/formatted-date';
import { lang as l10nLang } from '@ott/l10n';

import { narrowNonBreakingDelimiter, normalNonBreakingDelimiter } from './delimiters';

export const defaultOptions = {
  foldSameYear: true,
  foldSameMonth: true,
  foldSameDate: false,
  isShortMonth: false,
  showYear: false,
  // прятать год, если он совпадает с текущим
  hideCurrentYear: true,
  showWeekdays: false,
  lang: l10nLang,
};

function getFormattedDate(date, options = {}) {
  const { isShortMonth, lang, showMonth, showYear, showWeekdays, hideCurrentYear } = options;

  return formatDate({
    date,
    isShortMonth,
    lang,
    showYear,
    showMonth,
    showWeekday: showWeekdays,
    hideCurrentYear,
  });
}

// возвращает объект вида
// {
//   formattedStartDate,
//   delimiter,
//   formattedEndDate,
//   formattedPeriod
// }
export function formatPeriodToObject(props) {
  const options = {
    ...defaultOptions,
    ...props,
  };

  const {
    startDate,
    endDate,
    foldSameDate,
    foldSameMonth,
    foldSameYear,
    showYear,
    hideCurrentYear,
    showWeekdays,
  } = options;

  const isSameYear = startDate.getFullYear() === endDate.getFullYear();
  const isSameMonth = startDate.getMonth() === endDate.getMonth();
  const isSameDate = startDate.getDate() === endDate.getDate();
  const yearShouldBeFolded = isSameYear && foldSameYear && !showWeekdays;
  const monthShouldBeFolded = yearShouldBeFolded && isSameMonth && foldSameMonth && !showWeekdays;
  const dateShouldBeFolded = monthShouldBeFolded && isSameDate && foldSameDate;

  const pattern = new RegExp('^D');
  const isMonthFirst = pattern.test(getFormattedDate(startDate, options));

  const formattedEndDate = getFormattedDate(endDate, {
    ...options,
    showYear,
    hideCurrentYear,
    showMonth: !monthShouldBeFolded || !isMonthFirst,
  });

  if (dateShouldBeFolded) {
    return {
      formattedStartDate: '',
      delimiter: '',
      formattedEndDate,
      formattedPeriod: formattedEndDate,
    };
  }

  const formattedStartDate = getFormattedDate(startDate, {
    ...options,
    showYear: false,
    showMonth: !monthShouldBeFolded || isMonthFirst,
  });

  const delimiter = monthShouldBeFolded ? narrowNonBreakingDelimiter : normalNonBreakingDelimiter;
  const formattedPeriod = `${formattedStartDate}${delimiter}${formattedEndDate}`;
  return {
    formattedStartDate,
    delimiter,
    formattedEndDate,
    formattedPeriod,
  };
}

// экспортируется для переиспользования за пределами FormattedPeriod
export function formatPeriod(props) {
  const { formattedPeriod } = formatPeriodToObject(props);
  return formattedPeriod;
}
